import { getRootRoute } from './getRootRoute';
import { navigateToRoute } from './navigateToRoute';

export function handleHashChange() {
  navigateToRoute(getRootRoute());
}
